import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import { ApiClientService, Reg_kontakt } from '../../../services/api-client.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'app-registrovani-kontakt',
  templateUrl: './registrovani-kontakt.component.html',
  styleUrls: ['./registrovani-kontakt.component.scss']
})
export class RegistrovaniKontaktComponent implements OnInit {
  constructor(
    private apiClient: ApiClientService, 
    private cdRef: ChangeDetectorRef, 
    private userService: UserService
  ) {
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  gridData: any[] = [];
  loading: boolean = false;
  loadPanelPosition = { of: '#registrovaniKontaktGrid' };
  isUserModerator: boolean = false;

  @ViewChild('registrovaniKontaktGrid', { static: false }) registrovaniKontaktGrid: DxDataGridComponent;

  ngOnInit() {
    this.isUserModerator = this.userService.isUserAgroModerator();
    console.log('User is moderator:', this.isUserModerator);
    this.loadData();
  }

  async loadData() {
    this.loading = true;
    
    try {
      const result = await this.apiClient.registrovaniiKontaktAll();
      this.gridData = result;

    } catch (error) {
      console.error('Error loading registrovani kontakt data:', error);
    } finally {
      this.loading = false;
    }
  }

  async onDeleteClick(e: any) {
    this.loading = true;
    const registrovaniKontakt = e.row.data;

    try {
      await this.apiClient.registrovaniiKontaktDELETE(registrovaniKontakt.id);

      const index = this.gridData.findIndex(item => item.id === registrovaniKontakt.id);
      if (index > -1) {
        this.gridData.splice(index, 1);
        this.gridData = [...this.gridData]; // Trigger change detection
      }

      this.loading = false;
      this.cdRef.detectChanges();
    } catch (error) {
      this.loading = false;
      console.error('Error deleting registrovani kontakt:', error);
    }
  }
}